import { createAction } from 'redux-actions';

export const testAction = createAction('TEST');
export const getAdvertisementRequested = createAction('GET_ADVERTISEMENT_DATA_REQUESTED');
export const getAdvertisementReceived = createAction('GET_ADVERTISEMENT_DATA_RECEIVED');
export const getAdvertisementReceivedFailured = createAction('GET_ADVERTISEMENT_DATA_RECEIVED_FAILURED');
export const clearAdvertisement = createAction('CLEAR_ADVERTISEMENT_DATA');

export const loginOuterServerRequest = createAction('LOGIN_OUTER_SERVER_REQUEST');
export const loginOuterServerReceived = createAction('LOGIN_OUTER_SERVER_RECEIVED');
export const loginOuterServerReceivedFailure = createAction('LOGIN_OUTER_SERVER_RECEIVED_FAILURE');
export const clearLoginOuterServer = createAction('CLEAR_LOGIN_OUTER_SERVER');
